module.exports = __webpack_public_path__ + "static/img/招聘.5d29d427.png";